export function createFallbackName(id) {
    return `#${id}`;
}
